__turbopack_context__.v({
  "label": "mantineCheckbox-module-scss-module__J2jWea__label",
});
